import { useTheme } from "@emotion/react";
import { FileOpen, MoreVert } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useContext, useState } from "react";
import S3PresignedImage from "../../../components/S3PresignedImage";
import { AuthContext } from "../../../context/AuthContext";

const FileItem = ({ fileItem, onDelete, readOnly, onItemClick }) => {
  const { authToken, ezorder } = useContext(AuthContext);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [menuAnchor, setMenuAnchor] = useState(null);
  const openMenu = Boolean(menuAnchor);
  const handleMenuClick = (event) => {
    setMenuAnchor(event.currentTarget);
  };
  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const createPresignedUrl = async (s3Key) => {
    try {
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };

      let keySplit = s3Key.split("/");
      let identifier = keySplit[0];
      let resource = keySplit[1];
      let fileName = keySplit[2];
      const response = await ezorder.post(
        "/files/presignedUrl",
        {
          identifier,
          resource,
          fileName,
          actionType: "READ",
          contentType: "application/pdf",
        },
        data
      );
      return response.data.getUrl;
    } catch (error) {
      // console.log(error);
      throw Error("Unable to load presigned URL", { cause: error });
    }
  };

  const downloadDocument = async (doc) => {
    let presignedUrl = await createPresignedUrl(doc.file);

    // using Java Script method to get PDF file
    fetch(presignedUrl).then((response) => {
      response.blob().then((blob) => {
        console.log("BLOB", blob);
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        let fileName = doc.name;
        alink.download = fileName;
        alink.click();
      });
    });
  };

  return (
    <Card
      sx={{
        width: "100%",
        minHeight: "100%",
        flex: 1,
        position: "relative",
        cursor: "pointer",
      }}
    >
      <Box
        onClick={() => {
          // setOpenPreview(true);
          if (onItemClick) onItemClick();
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          flex: 1,
          position: "relative",
        }}
      >
        {fileItem.file.toLowerCase().endsWith(".apng") ||
        fileItem.file.toLowerCase().endsWith(".avif") ||
        fileItem.file.toLowerCase().endsWith(".gif") ||
        fileItem.file.toLowerCase().endsWith(".jpg") ||
        fileItem.file.toLowerCase().endsWith(".jpeg") ||
        fileItem.file.toLowerCase().endsWith(".jfif") ||
        fileItem.file.toLowerCase().endsWith(".pjpg") ||
        fileItem.file.toLowerCase().endsWith(".pjp") ||
        fileItem.file.toLowerCase().endsWith(".png") ||
        fileItem.file.toLowerCase().endsWith(".svg") ||
        fileItem.file.toLowerCase().endsWith(".webp") ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              //   aspectRatio: 1 / 1,
              position: "relative",
            }}
          >
            <S3PresignedImage s3Key={fileItem.file} />
          </Box>
        ) : (
          <FileOpen
            sx={{ fontSize: "245px", marign: 0, padding: 0 }}
            onClick={() => {
              downloadDocument(fileItem);
            }}
          />
        )}
      </Box>
      <CardContent>
        <Typography
          variant="subtitle2"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
          }}
        >
          {fileItem.name}
        </Typography>
      </CardContent>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        {/* <IconButton onClick={handleMenuClick}>
          <MoreVert />
        </IconButton> */}
        {/* <Menu anchorEl={menuAnchor} open={openMenu} onClose={handleMenuClose}>
          <MenuItem
            onClick={() => {
              download(fileItem.s3key, fileItem.name);
              handleMenuClose();
            }}
          >
            Download
          </MenuItem>
          {!readOnly && (
            <MenuItem
              onClick={() => {
                onDelete();
                handleMenuClose();
              }}
            >
              Delete
            </MenuItem>
          )}
        </Menu> */}
      </Box>
    </Card>
  );
};

export default FileItem;
